module.exports = __webpack_public_path__ + "img/EuclidEnercity-LightItalic-WebS.c9797d02.svg";